/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUniversalAccess} from '@fortawesome/pro-duotone-svg-icons';

const IepIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUniversalAccess} {...props} />
);

export default IepIcon;
